/**
 * vore-facets.js — estado de carregamento dos filtros da coleção.
 *
 * Os filtros e a ordenação de sections/vore-collection-grid.liquid usam os
 * custom elements do tema base (assets/facets.js): `facets-form-component`
 * atualiza a URL e re-renderiza a seção pela Section Rendering API.
 *
 * O tema base não mostra feedback visual durante essa busca. Este arquivo repõe
 * só isso:
 *
 *   1. ao disparar `filter:update`, marca a seção com `.vore-collection--loading`
 *   2. ao disparar `collection:rerendered`, remove a marca
 *
 * Sem dependências e sem estado próprio. Carregado por vore-collection-grid.liquid.
 */
(function () {
  if (window.voreFacetsLoadingInit) return;
  window.voreFacetsLoadingInit = true;

  var LOADING_CLASS = 'vore-collection--loading';

  document.addEventListener('filter:update', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var section = target.closest('.vore-collection');
    if (section) section.classList.add(LOADING_CLASS);
  });

  var clear = function () {
    var loading = document.querySelectorAll('.' + LOADING_CLASS);
    for (var i = 0; i < loading.length; i++) {
      loading[i].classList.remove(LOADING_CLASS);
    }
  };

  document.addEventListener('collection:rerendered', clear);
  window.addEventListener('popstate', clear);
})();
